import util from '@/common/util';
import axios from 'axios';
import dirty from '@/dirty';
import { getRootVar } from './init/data/getDataFromJsp';
import { blendRgba } from '@/common/utils/handle-color.js';
import { aiPreviewUrl } from '@/clientEnv';

function removeTrackingParams() {
    const url = new URL(window.location.href);
    const params = url.searchParams;
  
    const deleteParams = ['_gl'];
  
    let changed = false;
    for (const key of [...params.keys()]) {
        if (deleteParams.includes(key)) {
            params.delete(key);
            changed = true;
        }
    }
  
    if (changed) {
        url.search = params.toString();
        window.history.replaceState({}, '', url.toString());
    }
}
async function getApplyStatus(domainName) {
    if (!domainName) {
        return null;
    }
    try {
        const res = await axios.get('/api-site/mls/mls-org-infos', {
            params: { domain: domainName },
        });
        return res?.status?.code === 0 ? res.data : null;
    } catch (error) {
        console.error('getApplyStatus error:', error);
        return null;
    }
}
const extractRootVar = function(style, key) {
    let reg = new RegExp(`${key}:\\s*([^;}]*)`, 'm');
    let matches = style.match(reg);
    return matches ? matches[1] : '';
};

function calcHoverColor(globalData, style) {
    let bgColor = getRootVar('--g-btn-background');
    if (style) {
        bgColor = extractRootVar(style, '--g-btn-background');
    }
    let hoverColor = blendRgba('rgba(25,25,25,0.1)', bgColor);
    document.documentElement.style.setProperty('--color-hover', hoverColor);
}

export default function({
    globalData,
    platform: { platform },
    siteThemeStyle
}) {
    try {
        dirty({ globalData });

        //  Remove the parent window of the details page pop-up window loading
        if (util.inPopDetailPage) {
            window.parent.__curDetailPop.setLoading(false);
        }
    } catch (e) {}

    if (window.siteAppVm) {
        window.siteAppVm.$EventBus.$emit('siteTrack', {
            trackType: 'page-change'
        });
    }
    if (util.inCms) {
        document.body.classList.add(globalData.template);
    }
    // ai preview
    if (util.inIframePreview && Object.values(aiPreviewUrl).includes(location.hostname)) {
        document.body.classList.add('ai-preview');
    }
    
    if (platform.isMobile) {
        document.body.classList.add('mobile');
    }
    if (globalData.pageKey) {
        document.body.classList.add(globalData.pageKey);
    }
    if (globalData.isLandingPage) {
        document.body.classList.add('landing-page');
    }
    if (globalData.isTestSite) {
        document.body.classList.add('test-site');
    }
    if (globalData.siteStatus === 0) {
        document.body.classList.add('pending');
    }
    let websiteOnly = globalData?.agentCreator?.agentUser?.agentSource;
    if (websiteOnly === 'website_only') {
        document.body.classList.add('website-only');
    }

    /**
     * 22000 is the manual listing id - fixed value, it's a our internal data
     * we'll skip it
     */
    if (util.isReallyUser && globalData.mlsOrgs[0]?.id !== 22000) {
        const pageCheck = ['listing-detail', 'sold-detail', 'listing-detail-sold', 'active-compliance-check', 'sold-compliance-check'];
        if (pageCheck.includes(globalData.pageKey)) {
            getApplyStatus(globalData.websiteInfo?.domainName).then(mlsInfo => {
                if (!mlsInfo || !mlsInfo.length) {
                    return;
                }
                let _mlsInfo = mlsInfo.find(item => item.mlsOrgId === globalData.mlsOrgs[0].id);
                if (_mlsInfo && _mlsInfo.applyStatus !== 1) {
                    document.body.classList.add('pending');
                }
            });
        }
        let requestId = document.querySelector('#requestId');
        if (requestId) {
            // crm traffic report  Statistical data
            new Image().src = '/0.gif?u=' + (requestId.value || '');
        }
    }

    calcHoverColor(globalData, siteThemeStyle);

    removeTrackingParams();
}
